module.exports = __webpack_public_path__ + "static/media/express-light.88487091.png";